export default __webpack_public_path__ + "static/media/bikeicon.ebe228cb.svg";